import React from "react";
import Icon from "../Icon";

const MockTopBar = () => (
    <div className="clk-mk-topbar">
        <div className="clk-mk-topbar-right">
            <span className="clk-mk-topbar-item">
                <Icon name="widget" size={14} />
                Storage
            </span>
            <span className="clk-mk-topbar-item">
                <Icon name="chart" size={14} />
                Available Credit
            </span>
            <span className="clk-mk-topbar-item">
                <Icon name="chat" size={14} />
                Phone Connect
            </span>
            <button type="button" className="clk-mk-topbar-logout">
                Log Out
            </button>
        </div>
    </div>
);

export default MockTopBar;
